module.exports = __webpack_public_path__ + "SourceSansPro-Semibold.52984b3a4e09652a6fee.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/erikh/GitHub/Brickchain/oidc-demo/frontend/src/assets/fonts/SourceSansPro-Semibold.ttf
// module id = ../../../../../src/assets/fonts/SourceSansPro-Semibold.ttf
// module chunks = styles